"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectId = exports.ProjectIdBrand = exports.ProjectEntryKey = exports.ProjectEntryKeyBrand = void 0;
const identity_1 = require("./utils/identity");
// -------------------------------------------------------------------------------------------------
// Branded IDs
exports.ProjectEntryKeyBrand = Symbol('ProjectEntryKey');
exports.ProjectEntryKey = (0, identity_1.mkEntityIdCodec)(exports.ProjectEntryKeyBrand);
exports.ProjectIdBrand = Symbol('ProjectId');
exports.ProjectId = (0, identity_1.mkEntityIdCodec)(exports.ProjectIdBrand);
//# sourceMappingURL=identity.js.map